
import { message } from "antd"
import { getAgentUserInfo } from "../../../../../services/dct/visit"
import { AgentInfo, readWebAgentV2, writeWebAgentV2 } from "../../../../../utils/storage"

export enum EventEnum {
  EVENT_AGENT_NOTREADY = '置忙事件',
  EVENT_AGENT_READY = '置闲事件',
  EVENT_AGENT_LOGIN = '登陆成功事件',
  EVENT_AGENT_LOGIN_FAIL = '登陆失败事件',
  EVENT_WEBAGENT_LOGOUT = '登出成功事件',
  EVENT_WEBAGENT_LOGOUT_FAIL = '登出失败事件',
  EVENT_OUTBOUND_ALERTING_TP = '坐席振铃事件',
  EVENT_OUTBOUND_CONNECTED_TP = '坐席接听事件',
  EVENT_OUTBOUND_ALERTING_OP = '外呼客户振铃事件',
  EVENT_OUTBOUND_CONNECTED_OP = '坐席接听事件',
  EVENT_TP_DISCONNECT = '坐席挂断事件',
  EVENT_OP_DISCONNECT = '客户挂断事件',
}

export const EventName = 'WEB_AGENT_EVENT'

// 获取当前绑定坐席并缓存到本地
const getUserWebAgentInfo = async(): Promise<null | AgentInfo>=> {
  // 优先从本地缓存获取
  const userInfo = readWebAgentV2() as AgentInfo
  if(userInfo) {
    return userInfo
  }

  // 本地缓存没有去请求接口
  const { code, data } = await getAgentUserInfo<AgentInfo[]>()
  if(code === 0) {
    if (Array.isArray(data) && data.length > 0) {
      const value = data.shift() as AgentInfo
      writeWebAgentV2(value)
      return value
    }
  }

  return null
}


const resultHandler = (result: WebAgentNS.SimpleResult)=> {
  // console.log('?result', result)
  if (result.type === 'forceLogin') {
    if (result.code === '001') {
      message.error({
        title: '',
        content: result.msg
      })
    }
  }
}

const eventHandler = (event: WebAgentNS.SimpleEvent<WebAgentNS.ConnectedEventExt>)=> {
  PubSub.publish(EventName, event)
}

export const initAgent = ()=> {
  setTimeout(async ()=> {
    await start(eventHandler, resultHandler)
  }, 1000)
}

export const start = async (eventHandler: (event: WebAgentNS.SimpleEvent<WebAgentNS.ConnectedEventExt>)=> void, resultHandler: (result: WebAgentNS.SimpleResult)=> void)=> {
  // 获坐席信息
  const agentInfo = await getUserWebAgentInfo()
  if (null === agentInfo) {
    return
    // throw new Error('未获取到坐席信息')
  }

  window.WebAgent.init({
    useLocal: false,
    isUseCChat: false,
    loadBootstrap: 'unload',
    webRTCConfig: {
      tag: 'video-container',
      ringFile: 'https://cloud.ccod.com:1443/WebAgent/WA/sounds/bell_ring2.wav',
      ringTag: 'belling-ring',
      localTag: 'local-video'
    },
    WaParams: {
      ui: false,
      sipUseCphone: false
    },
    ChatParams: {},
    callback() {
      window.WebAgent.removeEventHandler(eventHandler)
      window.WebAgent.removeResultHandler(resultHandler)
      window.WebAgent.registerEventHandler(eventHandler)
      window.WebAgent.registerResultHandler(resultHandler)
    }
  })
}

export const login = ()=> {
  const data = readWebAgentV2() as AgentInfo
  const { agentId, entId, agentPwd: agentPassword } = data
  
  window.WebAgent.multiChannelLogin(window.WebAgent, {
    entId,
    agentId,
    agentPassword,
    waAutoLoginResult: false,
    isForce: true,
    isLocking() {
      console.log('?locking', arguments)
    },
    unLocking() {
      console.log('?unlocking', arguments)
    }
  })
}

export const busy = ()=> window.WebAgent.multiChannelState.agentBusy()

export const ready = ()=> window.WebAgent.multiChannelState.agentReady()

export const logout = ()=> window.WebAgent.multiChannelLogout()

export const hangup = ()=> window.WebAgent.extend.hangup()

export const makeCall = (outCallNumber: string)=> {
  window.WebAgent.extend.makeCall({
    isIntellectCall: true,
    outCallNumber,
  })
}